import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { useContext, useEffect, useState } from "react";

import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import Button from "components/CustomButtons/Button";
import CustomInput from "components/CustomInput/CustomInput";
import CustomSelect from "components/CustomSelect/CustomSelect";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";

import { LoginContext } from "contexts/LoginContext";
import createEnquiry from "services/EnquiryService/CreateEnquiry";
import updateEnquiry from "services/EnquiryService/UpdateEnquiry";
import GetAllPrograms from "services/ProgramServices/GetAllPrograms";
// import updateEnquiry from "services/EnquiryService/UpdateEnquiry";
// import getPrograms from "services/ProgramService/GetPrograms";

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const sourceOptions = [
    { id: "WalkIn", name: "Walk-in" },
    { id: "Online", name: "Online" },
    { id: "Website", name: "Website" },
    { id: "Referral", name: "Referral" },
    { id: "Phone", name: "Phone Call" },
];
const statusOptions = [
    { id: "New", name: "New" },
    { id: "Contacted", name: "Contacted" },
    { id: "Interested", name: "Interested" },
    // { id: "FollowUp", name: "Follow Up" },
    // { id: "Converted", name: "Converted" },
    { id: "Dropped", name: "Dropped" },
];


function AddEnquiry({ isEdit = false, initialData = null, afterFinish }) {
    const { user, providerId } = useContext(LoginContext);

    const [enquiryData, setEnquiryData] = useState({
        enquiryid: 0,
        name: "",
        mobile: "",
        email: "",
        providerId: providerId,
        programId: null,
        source: "",
        status: "New",
        createdBy: user ?? "system",
        updatedBy: user ?? "system",
    });

    const [programs, setPrograms] = useState([]);
    const [selectedProgramId, setSelectedProgramId] = useState(initialData?.programId || 0);
    const [open, setOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [severity, setSeverity] = useState("success");
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (isEdit && initialData) {
            setEnquiryData({
                ...initialData,
                updatedBy: user ?? "system",
            });
        }
    }, [isEdit, initialData, user]);

    useEffect(() => {
        const getAllProgramData = async () => {
            try {
                let getPrograms = await GetAllPrograms.getAllPrograms();
                const data = getPrograms?.$values?.length > 0 ? getPrograms?.$values : [];
                const filterData = data?.map(p => ({
                    id: p?.programId,
                    name: p?.name,
                }));
                setPrograms(filterData);
            }
            catch (e) {
                console.log("error getting programs", e);
            }
        }
        getAllProgramData()
    }, []);


    const validateForm = () => {
        let temp = {};

        if (!enquiryData.name?.trim()) {
            temp.name = "Name is required";
        }

        if (!enquiryData.mobile?.trim()) {
            temp.mobile = "Mobile number is required";
        } else if (!/^[6-9]\d{9}$/.test(enquiryData.mobile)) {
            temp.mobile = "Enter valid 10-digit mobile number";
        }

        if (enquiryData.email && !/^\S+@\S+\.\S+$/.test(enquiryData.email)) {
            temp.email = "Invalid email format";
        }

        if (!enquiryData.programId) {
            temp.programId = "Program is required";
        }

        if (!enquiryData.source) {
            temp.source = "Source is required";
        }

        if (!enquiryData.status) {
            temp.status = "Status is required";
        }

        setErrors(temp);
        return Object.keys(temp).length === 0;
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "mobile") {
            let cleanedValue = value?.replace(/\D/g, ""); // allow only digits
            cleanedValue = cleanedValue?.slice(0, 10); // limit to 10 digits

            setEnquiryData((prev) => ({
                ...prev,
                [name]: cleanedValue,
            }));
            return;
        }
        setEnquiryData((prev) => ({ ...prev, [name]: value }));
    };

    const showSnackBar = (message, sev = "success") => {
        setSeverity(sev);
        setAlertMessage(message);
        setOpen(true);
    };

    const handleClose = (_, reason) => {
        if (reason === "clickaway") return;
        setOpen(false);
    };

    const handleSubmit = async () => {
        if (!validateForm()) {
            showSnackBar("Please fix validation errors", "error");
            return;
        }

        try {
            setIsLoading(true);
            if (isEdit) {
                await updateEnquiry(enquiryData?.enquiryid, enquiryData);
                showSnackBar("Enquiry updated successfully");
            } else {
                await createEnquiry(enquiryData);
                showSnackBar("Enquiry created successfully");
            }
            setIsLoading(false);
            setTimeout(() => {
                afterFinish?.();
            }, 1200);
        } catch (err) {

            const message =
                err?.response?.data?.message || "Something went wrong";

            showSnackBar(message, "error");
        } finally {
            setIsLoading(false);

        }
    };


    return (
        <Card>
            <CardHeader color="rose" icon>
                <CardIcon color="rose">
                    <i className="material-icons">
                        {isEdit ? "edit" : "add"}
                    </i>
                </CardIcon>
                <h4>{isEdit ? "Edit Enquiry" : "Add Enquiry"}</h4>
            </CardHeader>

            <CardBody>
                <GridContainer>

                    <GridItem xs={12} sm={6} md={4}>
                        <CustomInput
                            labelText="Student Name *"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                                name: "name",
                                value: enquiryData.name,
                                onChange: handleChange,
                            }}
                            error={!!errors.name}
                            helperText={errors.name}
                        />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={4}>
                        <CustomInput
                            labelText="Mobile Number *"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                                name: "mobile",
                                type: "number",
                                maxLength: 10,
                                value: enquiryData.mobile,
                                onChange: handleChange,
                            }}
                            error={!!errors.mobile}
                            helperText={errors.mobile}
                        />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={4}>
                        <CustomInput
                            labelText="Email"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                                name: "email",
                                value: enquiryData.email,
                                onChange: handleChange,
                            }}
                            error={!!errors.email}
                            helperText={errors.email}
                        />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={4}>
                        <CustomSelect
                            label="Program"
                            options={programs}
                            value={selectedProgramId}
                            setvalue={(v) => {
                                console.log(v, "  ", v?.target?.value);
                                setSelectedProgramId(v);
                                setEnquiryData((prev) => ({ ...prev, ["programId"]: v }))
                            }
                            }
                            error={!!errors.programId}
                            helperText={errors.programId}
                        />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={4}>
                        <CustomSelect
                            label="Source *"
                            options={sourceOptions}
                            value={enquiryData.source}
                            setvalue={(v) =>
                                setEnquiryData((prev) => ({ ...prev, source: v }))
                            }
                            error={!!errors.source}
                            helperText={errors.source}
                        />

                        {/* <CustomInput
                            labelText="Source"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{
                                name: "source",
                                value: enquiryData.source,
                                onChange: handleChange,
                            }}
                        /> */}
                    </GridItem>

                    <GridItem xs={12} sm={6} md={4}>
                        <CustomSelect
                            label="Status"
                            options={statusOptions}
                            value={enquiryData.status}
                            setvalue={(v) =>
                                setEnquiryData((prev) => ({ ...prev, status: v }))
                            }
                            disabled={!isEdit}
                            error={!!errors.status}
                            helperText={errors.status}
                        />
                    </GridItem>


                </GridContainer>

                <Button
                    color="rose"
                    onClick={handleSubmit}
                    disabled={isLoading}
                    style={{ float: "right", marginTop: 20 }}
                >
                    {isLoading ? 'Loading...' : isEdit ? "Update" : "Create"}
                </Button>
            </CardBody>

            <Snackbar
                open={open}
                autoHideDuration={2000}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert severity={severity} onClose={handleClose}>
                    {alertMessage}
                </Alert>
            </Snackbar>
        </Card>
    );
}

export default AddEnquiry;
